// Copyright (c) 2022 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Actions from "../actions"
import * as Slice from "../slices/stats"
import { showSnackBar } from "../../snackbar/actions"
import { executor, Init, postExpectationService } from "../../../app/rpc"
import {
  ListLeavesRequestSchema,
  ListLeavesResponse,
} from "../../../generated/legebill/site/postexpectation/v4/post_expectation_pb"

type CreateLeaveRpc = (request: Init<typeof ListLeavesRequestSchema>) => Observable<ListLeavesResponse>

export const listLeaves = (listLeavesRpc: CreateLeaveRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listLeaves.match),
      mergeMap(action => listLeavesRpc(action.payload)
        .pipe(
          map(t => t.leaves),
          map(Slice.setLeaveList),
          catchError(() => concat(
            of(Actions.listLeavesErrored()),
            of(showSnackBar({
              message: t({ id: "msg_list_leaves_failed", message: "Failed to load leaves. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
              messageType: "ERROR",
            }))
          )),
        )
      ),
    )

const listLeavesRpc = (request: Init<typeof ListLeavesRequestSchema>): Observable<ListLeavesResponse> =>
  executor(() => postExpectationService.listLeaves(create(ListLeavesRequestSchema, request)))

export default listLeaves(listLeavesRpc)
